import { render, staticRenderFns } from "./TenantDetailsDialog.vue?vue&type=template&id=10ce8961&scoped=true&"
import script from "./TenantDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./TenantDetailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./TenantDetailsDialog.vue?vue&type=style&index=0&id=10ce8961&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ce8961",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VCardText,VForm,VTextField})
